/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { ValueType } from 'hems/common/utils';

export const ACTIVITY_HISTORY_SORT_COLUMN = {
  SITE_ID: 'siteId',
  DEVICE_ID: 'deviceId',
  DEVICE_TYPE: 'deviceType',
  PREVIOUS_DEVICE_ID: 'previousDeviceId',
  ACTIVITY_TYPE: 'activityType',
  EVENT_DATE: 'eventDate',
  UPDATE_USER: 'updateUser',
} as const;

export type ActivityHistorySortColumn = ValueType<typeof ACTIVITY_HISTORY_SORT_COLUMN>;

export const ACTIVITY_HISTORY_TYPE = {
  INSTALL: 'INSTALL',
  REPLACE: 'REPLACE',
  DELETE: 'DELETE',
} as const;

export type ActivityHistoryType = ValueType<typeof ACTIVITY_HISTORY_TYPE>;

export const ACTIVITY_HISTORY_TYPE_TEXT_KEY = {
  [ACTIVITY_HISTORY_TYPE.INSTALL]: 'code.acttypecd.30',
  [ACTIVITY_HISTORY_TYPE.REPLACE]: 'code.acttypecd.60',
  [ACTIVITY_HISTORY_TYPE.DELETE]: 'code.acttypecd.90',
} as const;

export const ACTIVITY_HISTORY_DEVICE_TYPE = {
  /** AC System - AC Combiner */
  AC_COMBINER: 'AC_COMBINER',
  /** AC System - ESS */
  ESS: 'ESS',
  /** AC System - Hub */
  HUB: 'HUB',
  /** AC System - Micro Inverter */
  MICRO_INVERTER: 'MICRO_INVERTER',
  /** AC System - Battery Pack */
  BATTERY_PACK: 'BATTERY_PACK',
  /** AC System 이외의 장비 타입 (ex. GW_INV) - production 환경에는 없음 */
  UNKNOWN: 'UNKNOWN',
} as const;

export type ActivityHistoryDeviceType = ValueType<typeof ACTIVITY_HISTORY_DEVICE_TYPE>;

export const ACTIVITY_HISTORY_DOWNLOAD_LIST_SIZE = 1000;

export const ACTIVITY_HISTORY_TYPE_TEXT_COLUMN = 'activityTypeText';

export const ACTIVITY_HISTORY_DEVICE_TYPE_TEXT_KEY = {
  [ACTIVITY_HISTORY_DEVICE_TYPE.AC_COMBINER]: 'device.ac_combiner',
  [ACTIVITY_HISTORY_DEVICE_TYPE.ESS]: 'device.ess',
  [ACTIVITY_HISTORY_DEVICE_TYPE.HUB]: 'device.hub',
  [ACTIVITY_HISTORY_DEVICE_TYPE.MICRO_INVERTER]: 'device.micro_inverter',
  [ACTIVITY_HISTORY_DEVICE_TYPE.BATTERY_PACK]: 'device.battery_pack',
  [ACTIVITY_HISTORY_DEVICE_TYPE.UNKNOWN]: 'device.unknown',
} as const;

export const ACTIVITY_HISTORY_DEVICE_TYPE_TEXT_COLUMN = 'deviceTypeText';
